// extracted by mini-css-extract-plugin
export default {"hiddenTitle":"CaseStudyHiddenSection_hiddenTitle__AGLY6"};